import React from 'react';
import { motion } from 'framer-motion';

const Network = () => {
  return (
    <section id="network" className="py-24 bg-brand-black text-white relative overflow-hidden">
      {/* Abstract map background */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <circle fill="#ffffff" cx="2" cy="2" r="1"></circle>
            </pattern>
          </defs>
          <rect x="0" y="0" width="100%" height="100%" fill="url(#dots)"></rect>
        </svg>
      </div>

      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:w-1/2"
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-1 bg-brand-red"></div>
              <h4 className="text-brand-red font-bold uppercase tracking-widest text-sm">Jaringan Luas</h4>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight">
              Tanpa Batas, <br/> <span className="text-brand-red">Tanpa Hambatan.</span>
            </h2>
            <p className="text-gray-300 mb-6 text-lg leading-relaxed">
              Kami didukung oleh infrastruktur jaringan yang tersebar di titik-titik strategis. Mulai dari pergudangan di area pelabuhan hingga agen representatif di kota-kota besar di lima benua.
            </p>
            <p className="text-gray-300 text-lg leading-relaxed">
              Dengan kombinasi akses laut, udara, dan darat, <strong className="text-white">tanjungprioklogistik.com</strong> memastikan bisnis Anda memiliki jangkauan yang tak terbatas, menembus batas geografis dengan efisien.
            </p>

            <div className="mt-10 grid grid-cols-3 gap-6 text-center">
              <div>
                <p className="text-4xl font-bold text-brand-red mb-2">5</p>
                <p className="text-sm text-gray-400 uppercase tracking-wider">Benua</p>
              </div>
              <div>
                <p className="text-4xl font-bold text-brand-red mb-2">100+</p>
                <p className="text-sm text-gray-400 uppercase tracking-wider">Kota Tujuan</p>
              </div>
              <div>
                <p className="text-4xl font-bold text-brand-red mb-2">24/7</p>
                <p className="text-sm text-gray-400 uppercase tracking-wider">Operasional</p>
              </div>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:w-1/2 relative"
          >
            <img 
              src="/assets/images/network.jpg" 
              alt="Global Network" 
              className="rounded-3xl shadow-2xl shadow-brand-red/10 border border-white/10"
            />
            {/* Glowing dot effect */}
            <div className="absolute top-1/4 left-1/4 w-3 h-3 bg-brand-red rounded-full shadow-[0_0_15px_rgba(224,26,34,0.8)] animate-pulse"></div>
            <div className="absolute top-1/2 right-1/3 w-3 h-3 bg-brand-red rounded-full shadow-[0_0_15px_rgba(224,26,34,0.8)] animate-pulse" style={{ animationDelay: '1s' }}></div>
            <div className="absolute bottom-1/3 left-1/2 w-3 h-3 bg-brand-red rounded-full shadow-[0_0_15px_rgba(224,26,34,0.8)] animate-pulse" style={{ animationDelay: '0.5s' }}></div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Network;